import One from '../../images/one.jpg'
import Two from '../../images/two.jpg'
import Three from '../../images/three.jpg'
import Four from '../../images/four.jpg'
import Five from '../../images/five.jpg'
import Six from '../../images/six.jpg'
import Seven from '../../images/eight.jpg'
import Eight from '../../images/eight.jpg'
import Nine from '../../images/nine.jpg'
import Ten from '../../images/ten.jpg'
import Eleven from '../../images/eleven.jpg'
import Toile1 from '../../images/toile1.jpg'
import Toile2 from '../../images/toile2.jpg'

export const PRODUCTS = [
  {
    id: 1,
    slug:'Sac à main',
    name: 'Sac à main',
    image: One,
    description:"Que ce soit pour une balade à la plage, un tour à l’université, un voyage ou encore une journée de travail nos sacs à mains ont l’aptitude de s’adapter à votre train de vie, leur capacité de contenance vous permettra d’y mettre du rangement et de gagner de l’espace, ainsi vous pourrez être sûr d’avoir l’essentiel auprès de vous dans chacun de vos déplacements.",
    price: 20,
    status: '',
    category:'sac-a-main',
  },
  {
    id: 2,
    slug:'Cartable',
    name: 'Cartable',
    image: Eight,
    description:'Il est toujours agréable de porter sur soi un cartable qui correspond à notre personnalité, et bien que nombreux ne le savent peut-être pas, les articles que nous avons sur nous en disent toujours long sur nos choix, le cartable que nous proposons renverra une image de promotion d’une mode responsable, en plus de donner de l’élégance à votre personne.',
    price: 30,
    status: '',
    category:'cartable',
  },
  {
    id: 3,
    slug: 'Housse pour ordinateur',
    name: 'Housse pour ordinateur',
    image: Eleven,
    description:'Arriver à garder son ordinateur lorsqu’on ne l’utilise pas à l’abri de la poussière est l’avantage premier de notre housse pour ordinateur, toute fois à cette qualité s’ajoute aussi la facilité qu’elle offre quand la nécessité de se déplacer avec notre ordinateur portable s’impose et bien au de la de cela nous avons aussi la réduction des risques lorsque s’il arrivait que votre ordinateur tombe par accident, grâce à la lousse que nous utilisons afin de protéger votre ordinateur portable.',
    price: 15,
    status: '',
    category:'housse',
  },{
    id: 4,
    slug:'Sac à main',
    name: 'Sac à main',
    image: Six,
    description:"Que ce soit pour une balade à la plage, un tour à l’université, un voyage ou encore une journée de travail nos sacs à mains ont l’aptitude de s’adapter à votre train de vie, leur capacité de contenance vous permettra d’y mettre du rangement et de gagner de l’espace, ainsi vous pourrez être sûr d’avoir l’essentiel auprès de vous dans chacun de vos déplacements.",
    price: 20,
    status: '',
    category:'sac-a-main',
  },
  {
    id: 5,
    slug:'Sac à main',
    name: 'Sac à main',
    image: Ten,
    description:"Que ce soit pour une balade à la plage, un tour à l’université, un voyage ou encore une journée de travail nos sacs à mains ont l’aptitude de s’adapter à votre train de vie, leur capacité de contenance vous permettra d’y mettre du rangement et de gagner de l’espace, ainsi vous pourrez être sûr d’avoir l’essentiel auprès de vous dans chacun de vos déplacements.",
    price: 20,
    status: '',
    category:'sac-a-main',
  },
  {
    id: 6,
    slug:'Toile',
    name: 'Toile',
    image: Toile1,
    description:"Faite sur un tissu en jute naturelles auquel nous rajoutons du pagne, nos toiles sont des éléments incontournables pour votre décoration intérieure, le caractère durable et imputrescible du jute rajouté aux qualités premières du coton qui compose le pagne la rend durable dans le temps. ",
    price: 30,
    status:'',
    category:'toile',
  },
  {
    id: 7,
    slug:'Toile',
    name: 'Toile',
    image: Toile2,
    description:"Faite sur un tissu en jute naturelles auquel nous rajoutons du pagne, nos toiles sont des éléments incontournables pour votre décoration intérieure, le caractère durable et imputrescible du jute rajouté aux qualités premières du coton qui compose le pagne la rend durable dans le temps. ",
    price: 30,
    status:'',
    category:'toile',
  },
  // More products...
]